'use strict';

angular.module('mandaeApp')
  .filter('addSpanLast', function() {
    return function(string) {
      var list = [];
      list = string.split(' ');
      var elementAdded = '<span>' + list[list.length - 1] + '</span>';
      var re = /(\([\u00E0-\u00FC\w\)]+)/;
      var m;

      if ((m = re.exec(list[list.length - 1])) !== null) {
        var teste = string;
        teste.replace(/(\([\u00E0-\u00FC\w\)]+)/, elementAdded);
      }
      return teste;
    }
  });
